import { Box, FormControl, Radio, RadioGroup } from '@mui/material';
import { Bike, EBike, EScooter, Scooter } from '~/assets/icons';
import useStore from '~/store';
import {
  EquipmentTypeId,
  EquipmentValue,
  getEquipmentIdFromType,
  searchEquipmentNameById
} from '~/utils/searchNameEquipment';
import RadioGroupCustom from './RadioComponentCustom';
import { containerMessage } from './styles';

interface EquipmentConfig {
  label: string;
  value: EquipmentValue;
  description: string;
  Icon: () => JSX.Element;
  id: EquipmentTypeId;
}

const equipments: EquipmentConfig[] = [
  {
    label: 'Bicicleta',
    value: 'bike',
    description: '*Nova (máx. 60 dias) ou até 3 anos',
    Icon: () => <Bike />,
    id: EquipmentTypeId.BICICLETA
  },
  {
    label: 'Bicicleta elétrica',
    value: 'ebike',
    description: '*Nova (máx. 60 dias) ou até 3 anos',
    Icon: () => <EBike />,
    id: EquipmentTypeId.BICICLETA_ELETRICA
  },
  {
    label: 'Autopropelido',
    value: 'escooter',
    description: '*Novo (máx. 60 dias)',
    Icon: () => <EScooter />,
    id: EquipmentTypeId.AUTOPROPELIDO
  },
  {
    label: 'Ciclomotor e Moto Elétrica',
    value: 'scooter',
    description: '*Novo(a) (máx. 60 dias)',
    Icon: () => <Scooter />,
    id: EquipmentTypeId.CICLOMOTOR_MOTO_ELETRICA
  }
];

const defaultEquipment: EquipmentConfig = equipments[0];

export const TypesOfEquipment = () => {
  const { equipmentId } = useStore((store) => {
    let equipmentId = store.insured_item.equipment_type_id;

    if (!equipmentId && store.insured_item.equipment_type) {
      equipmentId = getEquipmentIdFromType(store.insured_item.equipment_type);
    }

    if (!equipmentId && store.quote.equipment && store.quote.equipment !== 'false') {
      const equipmentConfig = equipments.find((e) => e.value === store.quote.equipment);
      equipmentId = equipmentConfig?.id || EquipmentTypeId.BICICLETA;
    }

    return { equipmentId };
  });

  const equipmentObj = equipments.find((each) => each.id === equipmentId) || defaultEquipment;
  const equipment = searchEquipmentNameById(equipmentId || EquipmentTypeId.BICICLETA);

  return (
    <Box sx={() => containerMessage()}>
      <FormControl>
        <RadioGroup aria-labelledby="radio-button-type-equipment" value={equipment} defaultChecked>
          <RadioGroupCustom
            equipment={equipmentObj.value}
            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }} />}
            description={equipmentObj.description}
            Icon={equipmentObj.Icon}
            label={equipmentObj.label}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};
